const showSessionTimeoutNotification = () => {
    $('#session-timeout-notification-modal').modal('show');
}

export const registerSessionTimeoutNotification = () => {
    const timeoutDuration = $('#session-timeout-notification-modal').data('timeout-duration');
    if (timeoutDuration) {
        setTimeout(showSessionTimeoutNotification, parseInt(timeoutDuration));
    }
}